import { bizServices } from 'businessCommon';
import { IPageData } from '@umu/umu-types';

const { Page } = bizServices;

class CommercializePage<T extends IPageData> extends Page<T> {
    constructor(data: T) {
        super({ gdprConfig: { disableDeclineAlways: true, disableDefaultDecline: true }, ...data });
    }
}
export default CommercializePage;
